
import styles from "./SpectacleDetailVideo.module.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PlayIcon from "assets/icons/play";
import { useEffect } from "react";
import { Link } from "react-router-dom";


const SpectacleDetailVideo = ({ video, thumb }) => {

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      zIndex: 10000,
      Image: {
        zoom: true,
        clickToClose: true,
        wheel: "slide",
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);
  return (
    <div className={styles.spectacleDetailVideo}>
      {/* <video width="100%" height="100%" controls src={video} poster={thumb}>
      </video> */}
      <Link className={styles.videoLayer} to={video} data-fancybox="video">
        <PlayIcon />
      </Link>
    </div >
  )
}


export default SpectacleDetailVideo;
